import { type ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { FolderIcon } from '@/components/icons/FolderIcon';
import { TextDocumentIcon } from '@/components/icons/TextDocumentIcon';
import { MailSendIcon } from '@/components/icons/MailSendIcon';
import { desktopShortcuts } from './shortcuts';
import { DesktopIcon } from './components/DesktopIcon';
import { ContactPanel } from './components/ContactPanel';

const iconMap: Record<string, ReactNode> = {
  folder: <FolderIcon fontSize="large" />,
  document: <TextDocumentIcon fontSize="large" />,
  mail: <MailSendIcon fontSize="large" />,
} as const;

export function HomePage() {
  return (
    <Stack direction="row" justifyContent="space-between" sx={{ m: 2 }}>
      {/* Desktop shortcuts */}
      <Box
        sx={{
          display: 'grid',
          gap: 3,
        }}
      >
        {desktopShortcuts.map((shortcut) => (
          <DesktopIcon
            key={shortcut.label}
            icon={iconMap[shortcut.icon]}
            to={shortcut?.to || undefined}
            href={shortcut?.href || undefined}
            label={shortcut.label}
          />
        ))}
      </Box>

      {/* Content */}
      <ContactPanel />
    </Stack>
  );
}
